export function constrain(value, min, max) {
  return Math.min(Math.max(value, min), max)
}



// WEBPACK FOOTER //
// ./src/shared/utils/general.js